//@ts-check
import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';

var styles = function styles(theme) {
  return createStyles({
    root: {
      position: 'relative'
    },
    progress: {
      height: 20,
      borderRadius: theme.shape.borderRadius
    },
    label: {
      position: 'absolute',
      top: 0,
      color: 'white'
    },
    leftLabel: {
      marginLeft: theme.spacing(0.5)
    },
    centerLabel: {
      left: 0,
      right: 0,
      textAlign: 'center'
    },
    running: {
      backgroundColor: theme.common.intention.running
    },
    error: {
      backgroundColor: theme.common.intention.error
    },
    success: {
      backgroundColor: theme.common.intention.success
    }
  });
};
/**
 * @param {Props & import('../types').FormatterProps<number> & import('@material-ui/core').WithStyles<typeof styles>} props
 */


var JobProgressFormatter = function JobProgressFormatter(_ref) {
  var value = _ref.value,
      label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      color = _ref.color,
      classes = _ref.classes;
  var labelEl = null;

  if (label) {
    var labelText = '';
    if (typeof label === 'boolean') labelText = value + '%';else labelText = label;
    labelEl = React.createElement(Typography, {
      component: "span",
      className: cx(classes.label, classes[labelPlacement + 'Label'])
    }, labelText);
  }

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(LinearProgress, {
    className: classes.progress,
    classes: {
      bar: classes[color]
    },
    variant: "determinate",
    value: value
  }), labelEl);
};

var COLOR_INTENTIONS_OBJ = {
  running: true,
  success: true,
  error: true
};
export var COLOR_INTENTIONS = Object.keys(COLOR_INTENTIONS_OBJ);
var LABEL_PLACEMENTS_OBJ = {
  left: true,
  center: true
};
export var LABEL_PLACEMENTS = Object.keys(LABEL_PLACEMENTS_OBJ);
/**
 * @typedef {object} Props
 * @property {number} value The value of the progress indicator. Value between 0 and 100.
 * @property {string | boolean} [label] Label to display. If true, the label will be set to "{value}%"
 * @property { keyof COLOR_INTENTIONS_OBJ } [color] The intention of the progress bar. Will be styled with the corresponding theme color.
 * @property { keyof LABEL_PLACEMENTS_OBJ } [labelPlacement] The intention of the progress bar. Will be styled with the corresponding theme color.
 */

/** @type {Partial<Props>} */

JobProgressFormatter.defaultProps = {
  value: 0,
  label: false,
  color: 'running',
  labelPlacement: 'center'
};
export default withStyles(styles, {
  name: 'ECJobProgressFormatter'
})(JobProgressFormatter);